var map = {
	"./ABW.png": 1651,
	"./AFG.png": 1730,
	"./AGO.png": 5860,
	"./ALB.png": 8985,
	"./ALG.png": 4771,
	"./AND.png": 4189,
	"./ANG.png": 5819,
	"./ANT.png": 3470,
	"./ARE.png": 9290,
	"./ARG.png": 7017,
	"./ARM.png": 5456,
	"./ARU.png": 5538,
	"./ASA.png": 993,
	"./ASM.png": 5217,
	"./ATG.png": 6097,
	"./AUS.png": 5664,
	"./AUT.png": 3348,
	"./AZE.png": 7776,
	"./BAH.png": 9469,
	"./BAN.png": 758,
	"./BAR.png": 1724,
	"./BDI.png": 6758,
	"./BEL.png": 5534,
	"./BEN.png": 1804,
	"./BER.png": 4587,
	"./BFA.png": 7675,
	"./BGD.png": 27,
	"./BGR.png": 7163,
	"./BHR.png": 5662,
	"./BHS.png": 4533,
	"./BHU.png": 9342,
	"./BIH.png": 8986,
	"./BIZ.png": 6715,
	"./BLR.png": 3479,
	"./BLZ.png": 7777,
	"./BMU.png": 936,
	"./BOL.png": 552,
	"./BOT.png": 5967,
	"./BRA.png": 5044,
	"./BRB.png": 6174,
	"./BRN.png": 4124,
	"./BRU.png": 8804,
	"./BTN.png": 6790,
	"./BUL.png": 9235,
	"./BUR.png": 5793,
	"./BWA.png": 5645,
	"./CAF.png": 6397,
	"./CAM.png": 5009,
	"./CAN.png": 7001,
	"./CAY.png": 1583,
	"./CGO.png": 1487,
	"./CHA.png": 2332,
	"./CHE.png": 7505,
	"./CHI.png": 6469,
	"./CHL.png": 908,
	"./CHN.png": 4464,
	"./CIV.png": 5399,
	"./CMR.png": 8164,
	"./COD.png": 9124,
	"./COG.png": 8431,
	"./COK.png": 2285,
	"./COL.png": 5933,
	"./COM.png": 8342,
	"./CPV.png": 2859,
	"./CRC.png": 6582,
	"./CRI.png": 9091,
	"./CRO.png": 8327,
	"./CUB.png": 2621,
	"./CYM.png": 616,
	"./CYP.png": 6005,
	"./CZE.png": 8799,
	"./DEN.png": 6686,
	"./DEU.png": 4442,
	"./DJI.png": 6167,
	"./DMA.png": 8943,
	"./DNK.png": 1366,
	"./DOM.png": 3980,
	"./DZA.png": 7139,
	"./ECU.png": 4759,
	"./EGY.png": 4669,
	"./ERI.png": 6467,
	"./ESA.png": 3267,
	"./ESP.png": 329,
	"./EST.png": 3606,
	"./ETH.png": 8318,
	"./FIJ.png": 6344,
	"./FIN.png": 6701,
	"./FJI.png": 8684,
	"./FRA.png": 4773,
	"./FSM.png": 4259,
	"./GAB.png": 1004,
	"./GAM.png": 3451,
	"./GBR.png": 4951,
	"./GBS.png": 8834,
	"./GEO.png": 7224,
	"./GEQ.png": 1661,
	"./GER.png": 4618,
	"./GHA.png": 9627,
	"./GIN.png": 520,
	"./GMB.png": 3167,
	"./GNB.png": 7583,
	"./GNQ.png": 6120,
	"./GRC.png": 6955,
	"./GRD.png": 6585,
	"./GRE.png": 8398,
	"./GRN.png": 5145,
	"./GTM.png": 8530,
	"./GUA.png": 5944,
	"./GUI.png": 3848,
	"./GUM.png": 732,
	"./GUY.png": 8306,
	"./HAI.png": 8230,
	"./HKG.png": 6382,
	"./HND.png": 9575,
	"./HON.png": 224,
	"./HRV.png": 2337,
	"./HTI.png": 4428,
	"./HUN.png": 4612,
	"./IDN.png": 803,
	"./INA.png": 69,
	"./IND.png": 7178,
	"./IRI.png": 1738,
	"./IRL.png": 1593,
	"./IRN.png": 7101,
	"./IRQ.png": 785,
	"./ISL.png": 9121,
	"./ISR.png": 7295,
	"./ISV.png": 54,
	"./ITA.png": 586,
	"./IVB.png": 6153,
	"./JAM.png": 7285,
	"./JOR.png": 8334,
	"./JPN.png": 3436,
	"./KAZ.png": 7990,
	"./KEN.png": 5602,
	"./KGZ.png": 1812,
	"./KHM.png": 5613,
	"./KIR.png": 2940,
	"./KNA.png": 7834,
	"./KOR.png": 3450,
	"./KSA.png": 9640,
	"./KUW.png": 3522,
	"./KWT.png": 9321,
	"./LAO.png": 370,
	"./LAT.png": 4791,
	"./LBA.png": 5392,
	"./LBN.png": 3544,
	"./LBR.png": 2035,
	"./LBY.png": 641,
	"./LCA.png": 6214,
	"./LES.png": 712,
	"./LIB.png": 9369,
	"./LIE.png": 1039,
	"./LKA.png": 1906,
	"./LSO.png": 310,
	"./LTU.png": 4732,
	"./LUX.png": 7914,
	"./LVA.png": 8433,
	"./MAD.png": 715,
	"./MAR.png": 1071,
	"./MAS.png": 698,
	"./MAW.png": 8853,
	"./MCO.png": 3581,
	"./MDA.png": 5379,
	"./MDG.png": 2221,
	"./MDV.png": 5156,
	"./MEX.png": 7695,
	"./MEX.svg.png": 4926,
	"./MGL.png": 6150,
	"./MHL.png": 6786,
	"./MKD.png": 6109,
	"./MLI.png": 7796,
	"./MLT.png": 6534,
	"./MMR.png": 4749,
	"./MNE.png": 1087,
	"./MNG.png": 6319,
	"./MON.png": 3723,
	"./MOZ.png": 8729,
	"./MRI.png": 514,
	"./MRT.png": 4943,
	"./MTN.png": 7904,
	"./MWI.png": 5511,
	"./MYA.png": 9137,
	"./MYS.png": 5455,
	"./NAM.png": 9757,
	"./NCA.png": 5302,
	"./NED.png": 8485,
	"./NEP.png": 6289,
	"./NER.png": 566,
	"./NGA.png": 4312,
	"./NGR.png": 157,
	"./NIC.png": 4636,
	"./NIG.png": 8051,
	"./NLD.png": 7831,
	"./NOR.png": 5883,
	"./NPL.png": 2508,
	"./NRU.png": 1709,
	"./NZL.png": 1499,
	"./OMA.png": 6926,
	"./OMN.png": 5908,
	"./PAK.png": 574,
	"./PAN.png": 6805,
	"./PAR.png": 3190,
	"./PER.png": 6507,
	"./PHI.png": 7767,
	"./PHL.png": 9770,
	"./PLE.png": 1251,
	"./PLW.png": 4884,
	"./PNG.png": 868,
	"./POL.png": 7692,
	"./POR.png": 6056,
	"./PRI.png": 8126,
	"./PRK.png": 3602,
	"./PRT.png": 9621,
	"./PRY.png": 2803,
	"./PSE.png": 1982,
	"./PUR.png": 3257,
	"./QAT.png": 6164,
	"./ROU.png": 7418,
	"./RSA.png": 5113,
	"./RUS.png": 7394,
	"./RWA.png": 4019,
	"./SAM.png": 3092,
	"./SAU.png": 9318,
	"./SDN.png": 9970,
	"./SEN.png": 9266,
	"./SEY.png": 4616,
	"./SGP.png": 6361,
	"./SIN.png": 5917,
	"./SKN.png": 7014,
	"./SLB.png": 762,
	"./SLE.png": 7306,
	"./SLO.png": 6588,
	"./SLV.png": 5164,
	"./SMR.png": 4507,
	"./SOL.png": 9008,
	"./SOM.png": 6423,
	"./SRB.png": 5062,
	"./SRI.png": 8990,
	"./STP.png": 6345,
	"./SUD.png": 1347,
	"./SUI.png": 2712,
	"./SUR.png": 1785,
	"./SVK.png": 3176,
	"./SVN.png": 2910,
	"./SWE.png": 9562,
	"./SWZ.png": 5905,
	"./SYC.png": 4968,
	"./SYR.png": 7687,
	"./TAN.png": 9999,
	"./TCD.png": 5024,
	"./TGA.png": 7816,
	"./TGO.png": 4239,
	"./THA.png": 7207,
	"./TJK.png": 2761,
	"./TKM.png": 776,
	"./TLS.png": 5414,
	"./TOG.png": 6822,
	"./TPE.png": 1057,
	"./TTO.png": 3526,
	"./TUN.png": 6365,
	"./TUR.png": 883,
	"./TUV.png": 2236,
	"./TZA.png": 5387,
	"./UAE.png": 850,
	"./UGA.png": 7238,
	"./UKR.png": 9207,
	"./URU.png": 5064,
	"./URY.png": 2632,
	"./USA.png": 7626,
	"./UZB.png": 1657,
	"./VAN.png": 7953,
	"./VCT.png": 9778,
	"./VEN.png": 6152,
	"./VIE.png": 3489,
	"./VIN.png": 4356,
	"./VNM.png": 4734,
	"./VUT.png": 2142,
	"./WSM.png": 1843,
	"./YEM.png": 7712,
	"./ZAF.png": 8236,
	"./ZAM.png": 8770,
	"./ZIM.png": 9256,
	"./ZMB.png": 1648,
	"./ZWE.png": 1006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;